import React from 'react';
import Typography from '@mui/material/Typography';

// eslint-disable-next-line react/prop-types
function ListInfo({ icon, title, value, margin, width }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: margin && '4px',
        width: width && width,
      }}
    >
      {icon}
      <Typography variant="caption" noWrap sx={{ fontSize: '14px' }}>
        {title}
      </Typography>
      <Typography variant="body1" style={{ fontSize: '16px' }} noWrap>
        {value}
      </Typography>
    </div>
  );
}

export default ListInfo;
